import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '../../../shared';
import { HomeMaterialModule } from '../../home-material/home-material.module';

import { AccountParticipationContentComponent } from './account-participation-content/account-participation-content.component';
import { SellerPreferencesManagementComponent } from './seller-preferences-management/seller-preferences-management.component';
import { SellerPreferencesTableComponent } from './seller-preferences-table/seller-preferences-table.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SharedModule,
    HomeMaterialModule,
  ],
  declarations: [
    AccountParticipationContentComponent,
    SellerPreferencesManagementComponent,
    SellerPreferencesTableComponent,
  ],
  exports: [
    AccountParticipationContentComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA,
  ],
})
export class ParticipationModule {}
